export function getCoupons() {
  return async (dispatch, _getState, {api}) => {
    const {data} = await api.getCoupons();
    dispatch({type: 'coupons/load', coupons: data.coupons});
    return data.coupons;
  }
}

export function saveCoupon(coupon) {
  return async (dispatch, _getState, {api}) => {
    const apiEndpoint = coupon.id ? api.updateCoupon : api.createCoupon;
    const {data} = await apiEndpoint(coupon);
    dispatch({type: 'coupon/load', coupon: data.coupon});
    return data.coupon;
  }
}
